import * as firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage';

// firebase init goes here
const storageBucket = "firebase-craigmyle-trucks.appspot.com";
const config = {
    apiKey: "AIzaSyCB_aHreTcyaMiWIeNcjRSbC9aXTvsw6BY",
    // authDomain: "craigmyle-trucks.firebaseapp.com",
    authDomain: "craigmyletrucks.com",
    databaseURL: "https://craigmyle-trucks.firebaseio.com",
    projectId: "firebase-craigmyle-trucks",
    storageBucket: storageBucket,
    messagingSenderId: "988778688785"
}

firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const currentUser = auth.currentUser

// firebase collections
const usersCollection = db.collection('users');
const contactsCollection = db.collection('contacts');
const inventoryCollection = db.collection('inventory');
const messagesCollection = db.collection('messages');
const uploadsCollection = db.collection('uploads');
const optionsCollection = db.collection('options');
const tagsCollection = db.collection('tags');
const categoriesCollection = db.collection('categories');
const statusesCollection = db.collection('statuses');
const receivedChecklistCollection = db.collection('checklist-received');
const salesReadyChecklistCollection = db.collection('sales-ready-checklist');
const bannersCollection = db.collection('banners');
const expensesCollection = db.collection('expenses');

const Timestamp = firebase.firestore.Timestamp


const imageThumbnails = {
    path: "thumbnails",
    resolutions: [
        "200x150",
        "600x450"
    ]
};
export {
    db,
    auth,
    storage,
    storageBucket,
    imageThumbnails,
    currentUser,
    usersCollection,
    contactsCollection,
    inventoryCollection,
    messagesCollection,
    uploadsCollection,
    optionsCollection,
    tagsCollection,
    categoriesCollection,
    statusesCollection,
    bannersCollection,
    receivedChecklistCollection,
    salesReadyChecklistCollection,
    expensesCollection,
    Timestamp,
}